export const Api_url = {
  //LOCATION
  SendLocation: '/user/edit_address',
  GetLocation: '/user/address',
  GOOGLE_LOCATION_API: 'https://maps.googleapis.com/maps/api/geocode/json',
  GetLocationByIp: '/user/get_location_by_ip',

  // -----CONTENT PLAYER --------
  GetLessonData: '/lesson',
  GetMskillLessons: '/get/lessons_in_microskill',
  CreateNotes: '/user_notes/create',
  GetNotes: '/user_notes',
  GetWatchedLesson: '/user_lessons/watched',
  MarkLessonWatch: '/user_lessons/mark_watched',
  GetDoubtsForLesson: '/faq',
  CreateDoubtForLesson: '/faq/create',
  CreateReplyForDoubt: '/faq_replies/create',
  GetMicroskillProgress: '/user_microskills/progress',
  GetSkillProgress: '/skill/progress',
  UpgradeDoubtToExpert: '/faq/upgrade_faq',
  EditNote: '/user_notes/edit',
  GetTasks: '/mskill_tasks',
  SubmitTask: '/user_tasks/submit',
  CreateTask: '/user_tasks/create',
  UpgradeUserTask: '/user_tasks/upgrade',
  MarkVideoUnplayable : '/track_error_videos',

  
  // -------- SKILLS AND MICRO-SKILLS ----------------
  GetSkill: '/skill',
  GetSkillsForCourse: '/skill/skills_in_course',
  GetSkillsForMegaMenu: '/skill/skills_in_course_mega_menu',
  GetSkillsForCourseDropDown: '/skill/skills_in_course_dd_menu',
  GetMSkillsForCourseDropDown: '/skill/mskills_in_course_dd_menu',
  GetMSkillsForCourse: '/mskill/mskills_in_course',
  GetMSkillsForskill: '/mskill/mskills_in_skill_v3',
  GetLastPlayedLesson: '/user/continue_learning',


  // GetMSkillsForskill: '/mskill/mskills_in_skill_v4_testing',
  GetAllCourses: '/course/all_courses',
  GetUserProgress: '/user_skill/mskill_progress',
  GetCourseById: '/course',
  GetCoursesToGetYouStarted: '/coursesToGetYouStarted',
  AddedToWishlist: '/user_wishlist',
  AddToWishlist: '/user_wishlist/add_new',
  DeleteFromWishlist: '/user_wishlist/delete',
  AddReview: '/user_skill_feedback/add_new',
  GetWishlist: '/user_wishlist/by_course',
  EnrollMSkill: '/mskill_enrolled/add_new',
  GetEnrolledMSkills: '/mskill_enrolled',
  ALLEnrolledMSkills: '/mskill_enrolled/all',
  GetCourseDetails: '/course/skills_in_course',
  GetAllMSkillWishlist: '/user_wishlist_mskill',
  GetMSkillWishlist: '/user_wishlist_mskill/by_course',
  AddMSkillToWishlist: '/user_wishlist_mskill/add_new',
  DeleteMSkillFromWishlist: '/user_wishlist_mskill/delete',
  GetMostViewedSkills: '/user_lessons/get_most_viewed',
  GetMostViewedMicroSkills: '/user_lessons/get_most_viewed_mskill',
  GetOurTopPic: '/OurTopPick_v2',
  GetFeaturedSkills: '/featuredSkills',
  GetFriendsLearningSkill: '/user/friends_learning_skill',
  PerksSection: '/skill/perks',
  OtherFriendsLearningSkill: '/user/friends_learning_other_skills',
  GetMetaTags: '/skill/meta_tags',
  GetReviews: '/user_skill_feedback',
  GetCourseMetaTags: '/course/meta_tags',
  SetActivationPhase : '/activation/mark_activated',
  ChangeActivationSkill : '/activation/change_course',


  // ---------- SEARCH -----------------------------

  GetSearchResults: '/searched_v2?search=',
  GetSearchResultsDropDown: '/searched_v2?search=',
  GetSearchOnboarding : '/search/content',

  // ------------- AUTH --------------------

  GetXanoAuthToken: '/continue_with_token',
  XanoUserSignup: '/auth/signup_v2',
  EditMobileNumber: '/edit/user_phone',
  SendOtpToMobile: '/mobile_verification/send_otp',
  VerifyOtp: '/mobile_verification/verify_otp',
  ResendOtp: '/mobile_verification/resend_otp',
  GetXanoAuthTokenFromUrl: '/redirect/get_token',
  SetOnboardingData: '/onboarding/new_v2',
  GetXanoAuthEmailToken: '/auth/login',
  GetXanoAuthPassWordResetToken: '/auth/password_reset_access',
  ResetPassword: '/auth/update_password_webapp',
  GetPhoneNumberFromEmail: '/auth/password_reset',
  SendVerificationMessage : '/user_verification/send',
  CheckOtp : '/user_verification/verify',
  AuthService : '/authorize',
  DeleteUser : '/user/delete',
  SetPassword : '/auth/update_password_webapp',

  //  --------USER DETAILS --------------
  GetProfileDetails: '/auth/me',

  // ---------- FLASH CARDS -----------------------------
  GetFlashCards: '/learntube_flashcards',

  //----------QUIZ-----------------------------
  GetQuizForLesson: '/quiz/quiz_in_lesson',
  UpdateQuizActivity: '/user_lessons/mark_completed',
  GetQuizActivity: '/user_lessons',
  GetChallengeInfo: '/user_microskills/get_challenge_data',
  CreateNewChallenge: '/user_challenge/add_new',
  DeclineChallenge: '/user_microskills/decline_challenge',
  AddQuizOptionSelection: '/quiz_options_attempt_count/add_new',
  GetQuizStats: '/quiz_options_attempt_count',
  UserTakenChallengeForSkill: '/user_challenge/get_status',
  ReportQuizSuggestions: '/quiz_reports/add_new',
  

  // ------------- USER ACTIVITY ----------------
  EnrollUserToSkill: '/skill/enroll_single_mskill',
  GetUserActivity: '/user/all_data',
  EditUserBio: '/user/edit_bio',
  EditUserName: '/user/edit_name',
  EditUserProfileImage: '/user/edit_profile_image',
  EditCoins: '/user_coins/edit',
  EditLastPlayed: '/user/edit_lastplayed',
  GetEnrolledSkills: '/user/enrolled_skills',
  GetUserEnrolledMSkills: '/user/enrolled_mskills',
  AddUserActivity: '/user_activity/add_new',
  GetUserCoins: '/user_coins',
  GetPointsTally: '/user_activity',
  GetUserLearnings: '/user/my_learnings',
  GetUserReferrals: '/user_referrals',
  ShaunEllisTest: '/user/shaunEllisTest',
  NPSTest: '/user/npsTest',
  YoutubeRemarks: '/user/youtube_remarks',
  VideoEditSuggestion: '/user/youtube_remarks_report_suggession',
  SyncGoogleContact: '/request_contacts_webapp',
  GetUserSearchRecommendations: '/user_searches/recommendations',
  AddSocialActivity: '/social/share_activity',
  CreateLinkedinPost: '/linkedin/share_image',
  GetDiscountByActivity: '/discount/by_activity',
  GetHighestDiscount: '/discount/highest',
  GetWebinars: '/webinargeek/get_webinars',
  SubscribeToWebinar: '/webinargeek/subscribe_to_broadcast',
  GetAvailableJobs: '/available_jobs/get_all',
  RequestJob: '/user_job_applications/add_new',
  DowngradeAccount: '/user/downgrade',
  GetRandomNumber : '/user_challenge/daily_completed_count',
  GetGoalsAndRoles : '/onboarding/goal_and_roles',

  // ------------- Certificate----------------------
  GetCertificate: '/user_certificates/create_v2',
  GetCertificates: '/user_certificates/get_all',
  UnlockCertificate: '/user_certificates/mark_unlocked',
  GetCertificateStatus: '/user_certificates/status',
  GetCertificatesByStatus: '/user_certificates/get_certificates_by_status',
  GetCertificateLink: '/user_certificates/generate_image_link_v2',
  GetShareCertificateLink : '/user_certificates/generate_shared_certificate_image',
  GetCertificateDetails: '/user_certificates/get_certificate',
  GetShareCertificateDetails : '/user_certificates/get_shared_certificate',
  GetShareSkillCertificateDetails : '/user_skill_certificates/get_shared_certificate',
  CreateSkillCertificate: '/user_skill_certificates/create',
  GetSkillCertificateLink: '/user_skill_certificates/generate_image_link_v2',
  GetShareSkillCertificateLink : '/user_skill_certificates/generate_shared_certificate_image_link_v2',
  UnlockSkillCertificate: '/user_skill_certificates/mark_unlocked',
  GetSkillCertificateProfileSection: '/user_skill_certificates/get_all',
  GetUserAccess: '/auth/check_access',
  GetAggregatedCertificateCount: '/analytics_saved_aggregated/certificate_count',
  GetCertificateReviews: '/certificate_reviews/get_all',
  SetUserCertificateStatus : '/user_certificates/update',
  CountAllCertificates : '/user_certificates/count_all',
  GetMicroSKillCompletedList : '/user_microskills/get_completed_mskills',
  


  // ------------------ WALKTHROUGH ---------------
  EditWalkthrough: '/user/walkthrough',

  // ------------------ Top 10 Leaderboard (Coins Earned) ---------------
  GetTopTenCoinsEarned: '/user_coins/top_ten',

  // ------------------ Reward Claim ---------------
  DeductAndClaim: '/marketplace_reward_claims/add_new',
  GetRecentlyClaimedRewards: '/marketplace_reward_claims/recent',

  // ------------------ Ad Banner ---------------
  GetAdBannerData: '/notifications_bar',
  GetUserActiveChallengesForNotification: '/user_challenge/get_active_challenges',
  GetNotificationData : '/notifications',

  // ------------------ RAZORPAY INTEGRATION ------------
  CreateRazorpayOrderId: '/razorpay_order/create_order',
  CreateRazorpayTransaction: '/razorpay_payment/transaction',

  // ----------------- USER SUBSCRIPTION -----------------
  GetCurrentSubscription: '/user_subscriptions/v2',

  //-------------------Pricing----------------------

  GetPrice: '/products/all_products',
  GetPlans: '/product_plans',
  GetTestPrice: '/products/all_products_dev',
  GetFaqsData: '/pricing_page/faqs',
  GetReviewData: '/pricing_page/reviews',
  GetLeads: '/lead_flags',
  GetToggleDiscount: '/timer',
  GetHighestDiscount: '/discount/highest',
  SendSupportRequest: '/support_requests/add_new',
  GetEligibility: '/user_microskills/get_completed_count',
  GetBookingProduct: '/products/by_id',
  LeadScoring: '/lead_scoring',
  GetBenefitSecton : '/premium_screen',
  SendPricingGoal : '/pricing_page_goal/add_new',
  GetPricingGoal : '/pricing_page_goal',


  // ---------------- User Challenges (for EXTENSION ) --------------------

  GetExtendedChallenges: '/user_challenge/get_extendable_challenges',
  EditChallengeStatus: '/user_challenge/extend',

  // --------------- JOB ELIGIBILITY SCORE --------------------------

  GetJobIndustryAndRolesData: '/eps_job_industries',
  SaveJobIndustryAndRolesData: '/eps_form_submissions/step_1',
  GetQualificationDegreeAndBranch: '/eps_education_qualifications',
  UploadResumeFile: '/user_resumes/add_new',
  SaveStep1: '/eps_form_submissions/step_1',
  SaveStep2: '/eps_form_submissions/step_2',
  SaveStep3: '/eps_form_submissions/step_3',
  SaveStep4: '/eps_form_submissions/step_4',
  getEPSData: '/eps_form_submissions',
  getEPSCertificateSearch: '/eps_certificates/search',
  getBoostTypeData: '/eps_boost',
  getRoleInCompany: '/eps_job_roles',
  saveChangesAfterDelete: '/eps_form_submissions/step_4_save',
  GetJESProjectionData : '/recommended_skill/check',
  UpdateEpsScore : '/recommended_skill/update_eps_score',
  ViewedJobScore : '/eps_form_submissions/mark_viewed',


  // HOMEPAGE WEEKLY LEADERBOARDS
  getLeaderboardData: '/leaderboard_by_activity/get_all',
  GetLeaderboardDataPerPage : '/leaderboard_by_activity/get_all_v2',

  //Dynamic banner
  GetDynamicBannerData : '/homepage_dynamic_banners/active',

  // Our Learners Work At
  GetOurLearnersWorkAt: '/user_placements',

  // Milestonebar achievements
  GetMilestoneData: '/user_milestone/get',
  PostUserMilestoneData: '/user_milestone/create',

  // Personalise Users
  PostUserPersonaliseCourseSelection: '/user_details/mark_personalized',

  // Recruiter
  SaveRecruiterDetails: '/recruiter/register',
  GetRelevantProfiles: '/get_relevant_profiles',
  GetProfileByEmail: '/get_profile_by_email',
};
